<ul>
    @for (note of notesBeforeFirstSubChapter; track note) {
        <li>
            <sidebar-single-note [note]="note"></sidebar-single-note>
        </li>
    }
</ul>

<ul class="subchapter-notes">

    @for (subchapterNote of chapterNotes; track subchapterNote; let i = $index) {
        <li>
            @if (subchapterNote.notes.length > 0) {
                <div>
                    <div class="content-description">
            <span class="width-90">
              <span>{{ hierarchyMap.get(subchapterNote.chapter.id).join('.') }}</span>
              <span>{{ subchapterNote.chapter.title }}</span>
            </span>
                    </div>
                    <ul>
                        @for (note of subchapterNote.notes; track note) {
                            <li>
                                <sidebar-single-note [note]="note"></sidebar-single-note>
                            </li>
                        }
                    </ul>
                </div>
            }
        </li>
    }
</ul>